import {ProductTileV2} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_tile_v2.types';
import {ProductRecommendation} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/recommendation_sections.types';

const baseTile: ProductTileV2 = {
  productId: 12345,
  link: {
    url: '/p/brand/product-name-12345',
    external: false,
  },
  gallery: {
    initialElementIndex: 0,
    elements: [
      {
        type: {
          $case: 'image',
          image: {
            image: {
              src: 'https://cdn.aboutstatic.com/file/images/test-product.jpg',
              description: 'Test Product Image',
              isEnclosed: false,
            },
          },
        },
      },
    ],
  },
  availableSizes: ['S', 'M', 'L'],
  brandTracker: {
    id: 100,
    name: 'Test Brand',
  },
  productTracker: {
    productId: 12345,
    productName: 'Test Product Name',
    isSponsored: false,
    sponsoredType: 'not_sponsored',
    linkTarget: '/p/brand/product-name-12345',
    isSoldOut: false,
  },
  priceV2: {
    finalPrice: {
      priceLabel: {text: 'EUR 29.99'},
    },
    badge: [],
    tracker: {
      currencyCode: 'EUR',
      priceWithoutTax: 2521,
      price: 2999,
      fullPrice: 2999,
    },
  },
  price: {
    price: {
      amount: 2999,
      currencyCode: 'EUR',
    },
    reductions: [],
    hasDifferentPrices: false,
    tracker: {
      currencyCode: 'EUR',
      price: 2999,
      priceWithoutTax: 2521,
      fullPrice: 2999,
    },
    priceTags: [],
  },
  colors: [
    {
      productId: 12345,
      color: {
        $case: 'simple',
        simple: {
          colors: [
            {
              hexCode: '#000000',
              isLightColor: false,
            },
          ],
        },
      },
    },
  ],
  badges: [],
  brandName: 'Test Brand',
  adpSection: {
    productImageType: 1,
  },
};

export const devMovUpsellingRecommendationSection: ProductRecommendation = {
  headline: 'Free shipping with these items',
  subline: '',
  promotionTracking: {
    name: 'mov_upselling_reco',
  },
  deprecatedProducts: {
    itemPreferences: {
      showProductNames: false,
      preferredProductImageType: 2,
      preferredTileSize: 1,
    },
    products: [],
  },
  products: [
    baseTile,
    {
      ...baseTile,
      productId: 12346,
      productName: 'MOV Product 2',
      productTracker: {
        ...baseTile.productTracker,
        productId: 12346,
        productName: 'MOV Product 2',
        linkTarget: '/p/brand/product-name-12346',
      },
      link: {
        ...baseTile.link,
        url: '/p/brand/product-name-12346',
      },
    },
  ],
};
